import { PractitionerHealthcareProviderType } from '@dreryk/egabinet-personnel-frontend-api';

import { useGetCurrentPractitionerGlobalState } from '../currentPractitioner/useGetCurrentPractitionerGlobalState';

export const useGetCurrentHealthcareProviderType = (): PractitionerHealthcareProviderType => {
   // TODO DREGAB-25028 Przeniesienie funkcjonalność integracji z Pharmindexem do panelu support
   const currentPractitioner = useGetCurrentPractitionerGlobalState();
   return currentPractitioner?.healthcareProviderType ?? 'HEALTHCARE_PRACTICE';
};
